import { useContext } from "react";
import { PageSizeContext } from "../../../context/context.page";
import { useItemCount } from "../../item/core/ItemQueryCount";
import { useSearchParamsHandler } from "../../../hooks/useSearchParamsHandler.ts";

const PageSelect = () => {
  const itemCount = useItemCount();
  const { pageSize } = useContext(PageSizeContext);
  const pages = Math.ceil(itemCount / pageSize);
  const { set } = useSearchParamsHandler("page");

  const selectPage = (page: number) => {
    set(String(page));
    scrollTo();
  };
  return (
    <div className="grid grid-cols-5 gap-2">
      {[...Array(pages)].map((_, i) => {
        const num = i;
        return (
          <button
            className="btn btn-ghost bg-base-100/70"
            key={num}
            value={num}
            onClick={() => selectPage(num)}
          >
            {num + 1}. Seite
          </button>
        );
      })}
    </div>
  );
};
export default PageSelect;
